export const NOT_FOUND = 'Not Found';
export const INVALID_URL = 'Invalid URL';
export const SERVER_CONNECTION_FAIL = 'api server has been shut down';
